import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[innerHTML], [innerHtml]',
    standalone: false
})
export class CmInnerHtmlSpacingDirective {
	@HostBinding('class.cm-localized-content')
	elementClass = true;

	constructor() {}
}
